<template>

	<div>
		<LazyMsgDialog v-model:visible="msgDlgVisible" :msg="msg" :buttons="buttons" :title="title" />
		<LazyR3InputBox />
		<SystemSettings v-if="showSystemSettingsDialog" v-model:show="showSystemSettingsDialog" />
		<CalculadoraDeCaixa v-if="calculadoraDeCaixa.visible.value" :parent="globalDialogs" />
		<LazyDisconnection v-model:show="showDisconnectionDialog" />
		<LazyFuncSelecionaOpcao v-if="_visible" :fields-headers="_fieldsHeaders" :fields-names="_fieldsNames"
			:values="_values" />
		<LazyDBConexaoErro v-model:visible="dbConnectionErrorVisible" />

		<!-- Modal global de validação DUN14/EAN13 e Peso Variável -->
		<ModalAuditoriaVolumeDun14 v-if="fDun14.visible.value" />

		<!-- LIST_F1 — origem no banco (F10 nos campos com dbTable/dbField) -->
		<FieldDbInfoDialog />

		<!-- <ModalNoConection v-model:show="showModalNoConection" /> -->
	</div>

</template>

<script lang="ts" setup>
	// {$R globalDialogs/globalDialogs.vue}

	// Modu Controle
	import SystemSettings from "~/components/modal/SystemSettings.vue";
	import type { msgDialogPropsParams } from "~/types/components/DMODU_CONTROLE/msgDialog.types";
	// import Disconnection from "./modal/Disconnection.vue";
	import CalculadoraDeCaixa from '~/components/modal/CalculadoraDeCaixa.vue';
	import { GlobalDialogs } from "~/classes/globalDialogs/globalDialogs";
	import { useMessageDlg } from '~/composables/useMessageDlg';
	import ModalAuditoriaVolumeDun14 from '~/components/auditoriaVolumesCarga/ModalAuditoriaVolumeDun14.vue';
	import { useAuditoriaVolumeDun14 } from '~/composables/useAuditoriaVolumeDun14';
	import FieldDbInfoDialog from '~/components/modal/FieldDbInfoDialog.vue';

	const { $r3ModuControleEvents, $r3ConfiguracoesEvents, $logger, $networkBus } = useNuxtApp();

	const { visible: msgDlgVisible, msg, buttons, title } = useMessageDlg();
	const { visible: dbConnectionErrorVisible } = useDBConnectionError();
	const { _fieldsHeaders, _fieldsNames, _values, _visible } = useFuncSelecionaOpcao();

	type globalDialogs = "MODU_CONTROLE_MSG_DIALOG" | "SYSTEM_SETTINGS_DIALOG" | "DISCONNECTION_DIALOG";
	const globalDialogActive = ref<globalDialogs>();

	// Configuracoes
	// Visibilidade dos modais
	const showSystemSettingsDialog = ref<boolean>(false);
	const showDisconnectionDialog = ref<boolean>(false);
	const showModuControleMessageDialog = ref<boolean>(false);

	// classes ref
	const { calculadoraDeCaixa } = useCalculadoraDeCaixa();

	/**
	 * Instância do modal DUN14 injetada de app.vue (criada lá como raiz da árvore).
	 * globalDialogs apenas controla a visibilidade e renderiza o componente.
	 */
	const { instancia: fDun14 } = useAuditoriaVolumeDun14();

	function verificaCalculadoraDeCaixa() {
		console.log("Verifica calculadora de caixa global dialogs: ", calculadoraDeCaixa);
		// Simplificando a lógica e removendo o console.log que pode ser problemático
		return calculadoraDeCaixa.visible.value
	}

	const globalDialogs = new GlobalDialogs()



	onMounted(() => {
		//$r3ModuControleEvents.on("MsgDlg", (args) => {

		// console.log("args: ", args)
		// msgDialogContent.value!.mensagem = args[0]?.mensagem;
		// msgDialogContent.value!.botoes = args.botoes ? args.botoes : [];
		// msgDialogContent.value!.mensagem = args.mensagem;
		// msgDialogContent.value!.tipo = args.tipo;
		// msgDialogContent.value!.titulo = args.titulo;
		// showModuControleMessageDialog.value = true;

		//});

		// msgDialogContent.value!.botoes = botoes.value ? botoes.value : []
		// msgDialogContent.value!.mensagem = mensagem.value;
		// msgDialogContent.value!.tipo = tipo.value;
		// msgDialogContent.value!.titulo = titulo.value;
		// showModuControleMessageDialog.value = visivel.value;



		$r3ConfiguracoesEvents.on('show', () => {
			console.log('Dialog configurações mostrado')
			showSystemSettingsDialog.value = true;
		});

		// teste
		// $networkBus.on("disconnected", () => {
		//   showDisconnectionDialog.value = true
		// })
	})


</script>


<style scoped></style>